import { ecosystem, ecosystemSection, type EcosystemItem } from '@/content/site'

import { Reveal } from './shared/Reveal'
import { SplitTitle } from './shared/SplitTitle'

const ROLE_TEXT: Record<EcosystemItem['role'], string> = {
  source: 'text-node-source',
  agent: 'text-node-agent',
  engine: 'text-node-engine',
  graph: 'text-node-graph',
  output: 'text-node-output',
}

export function EcosystemSection() {
  return (
    <section id="ecosystem" className="py-16 md:py-24">
      <div className="shell">
        <Reveal>
          <p className="eyebrow">{ecosystemSection.eyebrow}</p>
        </Reveal>

        <h2 className="max-w-2xl font-sans text-[1.6rem] md:text-[2.15rem] font-bold tracking-[-0.02em] leading-[1.16]">
          <SplitTitle text={ecosystemSection.title} />
        </h2>

        <Reveal i={1}>
          <p className="mt-5 max-w-[46rem] text-[0.95rem] md:text-[1.05rem] leading-[1.75] text-ink-dim">
            {ecosystemSection.intro}
          </p>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-px overflow-hidden rounded-lg border border-hairline bg-hairline sm:grid-cols-2 lg:grid-cols-4">
          {ecosystem.map((item, i) => (
            <Reveal key={item.name} i={i} className="h-full">
              <article className="group flex h-full flex-col bg-bg p-5 transition-colors hover:bg-accent/5 md:p-6">
                {/* input → product → output, the ecosystem's three-tier notation */}
                <p className="font-mono text-[0.63rem] uppercase tracking-[0.18em] text-ink-mute">
                  {item.input}
                </p>
                <h3
                  className={`mt-1 font-sans text-lg font-bold tracking-tight ${ROLE_TEXT[item.role]}`}
                >
                  {item.name}
                </h3>
                <p className="font-mono text-[0.63rem] uppercase tracking-[0.18em] text-accent/70">
                  {item.output}
                </p>
                <p className="mt-3 font-paragraph text-xs leading-relaxed text-ink-dim md:text-[0.82rem]">
                  {item.body}
                </p>
              </article>
            </Reveal>
          ))}

          {/* Fills the 8th cell so the grid stays rectangular at lg:grid-cols-4 */}
          <Reveal i={ecosystem.length} className="hidden lg:block">
            <article className="flex h-full flex-col justify-between bg-bg p-5 md:p-6">
              <p className="font-mono text-[0.63rem] uppercase tracking-[0.18em] text-ink-mute">
                {ecosystemSection.filler.label}
              </p>
              <p className="mt-3 font-paragraph text-xs leading-relaxed text-ink-dim">
                {ecosystemSection.filler.body}
              </p>
            </article>
          </Reveal>
        </div>
      </div>
    </section>
  )
}
